const initState = {
	fetching: false,
	fetched: false,
	error: null,
	payload: {},
	saved: false,
	message: null,
	dn: {},
	isDeleted: false,
};

const dnReducer = (state = initState, action) => {
	switch (action.type) {
		case 'DN_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'DN_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DN_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				payload: action.payload.data,
				error: null,
				saved: false,
				isDeleted: false
			};
		case 'SAVE_DN_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'SAVE_DN_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'SAVE_DN_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'GET_DN_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'GET_DN_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'GET_DN_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				dn: action.payload.data,
				error: null,
				saved: false,
			};
		case 'UPDATE_DN_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'UPDATE_DN_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'UPDATE_DN_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'DELETE_DN_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'DELETE_DN_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DELETE_DN_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				isDeleted: true
			};
		default:
			return state;
	}
};

export default dnReducer;
